export default __webpack_public_path__ + "static/summer_containers74-a425f50d67889ceb4a60530420f77df7.webp";